import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"
import * as style from "./src/templates/1_top/style.module.css"

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        const fadeInClass = "fadeInUp";
        const appearClass = "appear";
        const scrollClass = style.scroll;

        const fadeInElements = document.querySelectorAll(`.${fadeInClass}`);
        const appearElements = document.querySelectorAll(`.${appearClass}`);
        const scrollElements = document.querySelectorAll(`.${scrollClass}`);

        // fadeIn 用の observer
        const fadeInObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            { threshold: 0.1 }
        );

        // scroll 用の observer（画面下から20%上がトリガー）
        const appearObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("on");
                    }
                });
            },
            {
                root: null,
                rootMargin: "0px 0px -10%", // 下から20%を減らした位置
                threshold: 0,
            }
        );


        // scroll 用の observer（画面下から20%上がトリガー）
        const scrollObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add(style.on);
                    }
                });
            },
            {
                root: null,
                rootMargin: "0px 0px -10%", // 下から20%を減らした位置
                threshold: 0,
            }
        );


        fadeInElements.forEach((el) => fadeInObserver.observe(el));
        appearElements.forEach((el) => appearObserver.observe(el));
        scrollElements.forEach((el) => scrollObserver.observe(el));

        // cleanup
        return () => {
            fadeInElements.forEach((el) => fadeInObserver.unobserve(el));
            appearElements.forEach((el) => appearObserver.unobserve(el));
            scrollElements.forEach((el) => scrollObserver.unobserve(el));
        };
    }
};